import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Component, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BreadcrumbsService } from 'src/app/services/breadcrumbsService';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { ConductivityprofilesService } from 'src/app/services/conductivityprofiles/conductivityprofiles.service';
import { EventlogsService } from 'src/app/services/eventlogs/eventlogs.service';
@Component({
  selector: 'app-navbar',
  standalone: true,
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar1.component.css'],
  imports: [CommonModule, RouterModule, NgbDropdownModule],
})
export class NavbarComponent {
  isHover: boolean | undefined;
  opdata = false;
  eventlogs = false;
  conductivityprofiles = false;
  graphs = false;
  projects = false;
  admin = false;
  help = false;
  resources = false;
  restore = false;
  to: any;
  accounts = false;


  constructor(private router: Router, private commonModule: CommonModule,
    private breadcrumbsMenuService: BreadcrumbsService,
    private plantService: PlantsService,
    private eventlogService: EventlogsService,
    private conductivityprofilesservice: ConductivityprofilesService
  ) {}

  ngOnInit() {
     this.plantService.getAllPlant().subscribe(res => {
    this.plantService.setPlants(res);
  });
  }

  //loggedInuserRole = JSON.parse(sessionStorage.getItem('currentUser')!);
  loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')));
  Role = this.loggedInuserRole.role;
  firstName = this.loggedInuserRole.firstName;
  loggedInUserId = this.loggedInuserRole.userId;

setMenu(menu: string, subMenu: string) {
  this.breadcrumbsMenuService.setMenuName(menu, subMenu);
      //  store in localStorage
  localStorage.setItem('menuName', menu);
  localStorage.setItem('subMenuName', subMenu);

}


  onMouseOveropdata() {
    this.eventlogs = false;
    this.conductivityprofiles = false;
    this.projects = false;
    this.admin = false;
    this.help = false;
    this.accounts = false;
    this.graphs = false;
    this.isHover = true;
    this.opdata = true;
    clearTimeout(this.to);
  }

  onMouseOutopdata() {
    this.to = setTimeout(() => {
      this.opdata = false;
      this.isHover = false;
    }, 2000);
  }

  onMouseOvereventlogs() {
    this.opdata = false;
    this.conductivityprofiles = false;
    this.projects = false;
    this.graphs = false;
    this.accounts = false;
    this.admin = false;
    this.help = false;
    clearTimeout(this.to);
    this.isHover = true;
    this.eventlogs = true;
  }
  onMouseOuteventlogs() {
    this.to = setTimeout(() => {
      this.eventlogs = false;
      this.isHover = false;
    }, 2000);
  }

  onMouseOverconductivityprofiles() {
    this.opdata = false;
    this.eventlogs = false;
    this.projects = false;
    this.graphs = false;
    this.accounts = false;
    this.admin = false;
    this.help = false;
    clearTimeout(this.to);
    this.isHover = true;
    this.conductivityprofiles = true;
  }
  onMouseOutconductivityprofiles() {
    this.to = setTimeout(() => {
      this.conductivityprofiles = false;
      this.isHover = false;
      // doing some other stuff...
    }, 2000);
  }
  onMouseOvergraphs() {
    this.opdata = false;
    this.eventlogs = false;
    this.conductivityprofiles = false;
    this.admin = false;
    this.help = false;
    this.accounts = false;
    this.projects = false;
    clearTimeout(this.to);
    this.isHover = true;
    this.graphs = true;
  }

  onMouseOutgraphs() {
    this.to = setTimeout(() => {
      this.graphs = false;
      this.isHover = false;
      // doing some other stuff...
    }, 2000);
  }

  onMouseOverprojects() {
    this.opdata = false;
    this.eventlogs = false;
    this.conductivityprofiles = false;
    this.graphs = false;
    this.accounts = false;
    this.admin = false;
    this.help = false;
    clearTimeout(this.to);
    this.isHover = true;
    this.projects = true;
  }
  onMouseOutprojects() {
    this.to = setTimeout(() => {
      this.projects = false;
      this.isHover = false;
      // doing some other stuff...
    }, 2000);
  }

  onMouseOveradmin() {
    this.opdata = false;
    this.eventlogs = false;
    this.conductivityprofiles = false;
    this.graphs = false;
    this.accounts = false;
    this.help = false;
    clearTimeout(this.to);
    this.projects = false;
    this.isHover = true;
    this.admin = true;
  }
  onMouseOutadmin() {
    this.to = setTimeout(() => {
      this.admin = false;
      this.isHover = false;
    }, 2000);
  }

  onMouseOverhelp() {
    this.opdata = false;
    this.eventlogs = false;
    this.conductivityprofiles = false;
    this.graphs = false;
    this.projects = false;
    this.accounts = false;
    this.admin = false;
    clearTimeout(this.to);
    this.isHover = true;
    this.help = true;
  }

  onMouseOuthelp() {
    this.to = setTimeout(() => {
      this.help = false;
      this.isHover = false;
      // doing some other stuff...
    }, 2000);
  }

  onMouseOverResources() {
    this.isHover = false;
    this.opdata = false;
    this.eventlogs = false;
    this.accounts = false;
    this.conductivityprofiles = false;
    this.graphs = false;
    this.projects = false;
    this.admin = false;
    this.help = false;
    this.resources = true;
  }

  onMouseOutResources() {
    this.resources = false;
  }

  onMouseOverRestore() {
    this.isHover = false;
    this.opdata = false;
    this.eventlogs = false;
    this.accounts = false;
    this.conductivityprofiles = false;
    this.graphs = false;
    this.projects = false;
    this.admin = false;
    this.help = false;
    this.restore = true;
  }

  onMouseOutRestore() {
    this.restore = false;
  }

  onMouseOveraccounts() {
    this.opdata = false;
    this.eventlogs = false;
    this.conductivityprofiles = false;
    this.graphs = false;
    this.projects = false;
    this.admin = false;
    this.help = true;
    clearTimeout(this.to);
    this.accounts = true;
    this.isHover = true;
  }

  onMouseOutaccounts() {
    this.to = setTimeout(() => {
      this.accounts = false;
      this.isHover = false;
      // doing some other stuff...
    }, 2000);
  }

  logout() {
    sessionStorage.clear();
    this.router.navigate(['login']);
  }

  goToDashboard() {

  this.plantService.setSelectedPlant(null);
  this.plantService.setSelectedTrain(null);
  this.plantService.setPlantValidation(false);

  this.eventlogService.setPlantId(null);
  this.eventlogService.setTrainId(null);

  this.conductivityprofilesservice.setPlantId(null);
  this.conductivityprofilesservice.setTrainId(null);

  localStorage.removeItem("menuName");
  localStorage.removeItem("subMenuName");

  this.router.navigate(['dashboard']);
}
}
